import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { arrayAverage } from '~/functions/helpers';
import { Module, useGetAccountWithEuTaxonomyDataQuery, useListMetricAssignmentsQuery } from '~/types/types';
import { euTaxonomyMinimumSafeguardsSectionIxId, netTurnoverNotionId, activityTurnoverNotionId, capexNotionId, activityCapexNotionId, opexNotionId, activityOpexNotionId } from '~/functions/eu-taxonomy';
export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup: function setup(__props) {
    var route = useRoute();
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var $i18n = useNuxtApp().$i18n;
    var sections = computed(function () {
      return [{
        label: $i18n.t('euTaxonomy.navigation.intro.label'),
        id: "/".concat(ventureId.value, "/eu-taxonomy/edit/intro")
      }, {
        label: $i18n.t('euTaxonomy.navigation.eligibilityCheck.label'),
        id: "/".concat(ventureId.value, "/eu-taxonomy/edit/eligibility"),
        percentageCompleted: completionEligibility.value
      }, {
        label: $i18n.t('euTaxonomy.navigation.assignment.label'),
        id: "/".concat(ventureId.value, "/eu-taxonomy/edit/assignment"),
        percentageCompleted: completionAlignmentAssignment.value
      }].concat(_toConsumableArray(alignmentChecks.value), [{
        label: $i18n.t('euTaxonomy.navigation.financialMetrics.label'),
        id: "/".concat(ventureId.value, "/eu-taxonomy/edit/financial"),
        percentageCompleted: completionEuTaxonomyFinancial.value
      }]);
    });
    var _useGetAccountWithEuT = useGetAccountWithEuTaxonomyDataQuery({
        id: ventureId.value || ''
      }),
      accountResult = _useGetAccountWithEuT.result,
      accountLoading = _useGetAccountWithEuT.loading;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var hasEuTaxonomyCheck = computed(function () {
      var _account$value;
      return (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.bookedModules.includes(Module.EuTaxonomy);
    });
    var variables = computed(function () {
      return {
        assigneeIds: [ventureId.value],
        metricNotionIds: [netTurnoverNotionId, activityTurnoverNotionId, capexNotionId, activityCapexNotionId, opexNotionId, activityOpexNotionId]
      };
    });
    var _useListMetricAssignm = useListMetricAssignmentsQuery({
        filters: variables.value
      }),
      financialEuTaxonomyMetricAssignmentsResult = _useListMetricAssignm.result,
      financialEuTaxonomyMetricAssignmentsLoading = _useListMetricAssignm.loading;
    var financialAssignments = computed(function () {
      var _financialEuTaxonomyM;
      return ((_financialEuTaxonomyM = financialEuTaxonomyMetricAssignmentsResult.value) === null || _financialEuTaxonomyM === void 0 ? void 0 : _financialEuTaxonomyM.listMetricAssignments) || [];
    });
    var completionEligibility = computed(function () {
      var _account$value2, _account$value3, _account$value3$busin;
      return (_account$value2 = account.value) !== null && _account$value2 !== void 0 && _account$value2.hasNoEligibleBusinessActivities || ((_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : (_account$value3$busin = _account$value3.businessActivities) === null || _account$value3$busin === void 0 ? void 0 : _account$value3$busin.length) > 0 ? 1 : 0;
    });
    var completionAlignmentAssignment = computed(function () {
      var _account$value4;
      return (_account$value4 = account.value) !== null && _account$value4 !== void 0 && _account$value4.areEuTaxonomyActivitiesInSyncWithQuestionnaire ? 1 : 0;
    });
    var sectionCompletionMapping = function sectionCompletionMapping(questionnaireAssignment) {
      if (!questionnaireAssignment) return {};
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(questionnaireAssignment.sectionCompletion.map(function (item) {
        return _defineProperty({}, item.sectionId, item);
      }))));
    };
    var completionEuTaxonomyFinancial = computed(function () {
      var hasActual = financialAssignments.value.map(function (e) {
        var _e$metricValues$find;
        return (e === null || e === void 0 ? void 0 : (_e$metricValues$find = e.metricValues.find(function (mv) {
          return (mv === null || mv === void 0 ? void 0 : mv.period) === '2024';
        })) === null || _e$metricValues$find === void 0 ? void 0 : _e$metricValues$find.actual) === null ? 0 : 1;
      });
      return arrayAverage.apply(void 0, _toConsumableArray(hasActual));
    });
    var alignmentQuestionnaire = computed(function () {
      var _account$value5;
      return (_account$value5 = account.value) === null || _account$value5 === void 0 ? void 0 : _account$value5.euTaxonomyQuestionnaire;
    });
    var completionSection = function completionSection(sectionId, completionMapping) {
      var _completionMapping$se, _completionMapping$se2;
      return (_completionMapping$se = (_completionMapping$se2 = completionMapping[sectionId]) === null || _completionMapping$se2 === void 0 ? void 0 : _completionMapping$se2.percentageCompleted) !== null && _completionMapping$se !== void 0 ? _completionMapping$se : 0;
    };
    var isEuTaxonomyActivitySection = function isEuTaxonomyActivitySection(section) {
      return (section === null || section === void 0 ? void 0 : section.ixId) !== euTaxonomyMinimumSafeguardsSectionIxId;
    };
    var completionAlignmentCheck = function completionAlignmentCheck(questionnaire, completionMapping) {
      var _questionnaire$questi, _questionnaire$questi2, _questionnaire$questi3, _questionnaire$questi4, _questionnaire$questi5, _questionnaire$questi6;
      if (!questionnaire) return 1;
      if (!(questionnaire !== null && questionnaire !== void 0 && (_questionnaire$questi = questionnaire.questionnaireAssignment) !== null && _questionnaire$questi !== void 0 && _questionnaire$questi.isEditable)) return 1;
      var activitySections = (_questionnaire$questi2 = (_questionnaire$questi3 = questionnaire.questionnaireTemplate) === null || _questionnaire$questi3 === void 0 ? void 0 : (_questionnaire$questi4 = _questionnaire$questi3.sections) === null || _questionnaire$questi4 === void 0 ? void 0 : _questionnaire$questi4.filter(isEuTaxonomyActivitySection)) !== null && _questionnaire$questi2 !== void 0 ? _questionnaire$questi2 : [];
      var minimumSafeguardsSection = (_questionnaire$questi5 = questionnaire.questionnaireTemplate) === null || _questionnaire$questi5 === void 0 ? void 0 : (_questionnaire$questi6 = _questionnaire$questi5.sections) === null || _questionnaire$questi6 === void 0 ? void 0 : _questionnaire$questi6.find(function (section) {
        return section.ixId === euTaxonomyMinimumSafeguardsSectionIxId;
      });
      var toCheck = activitySections.map(function (section) {
        return completionSection(section.id, completionMapping);
      });
      if (minimumSafeguardsSection !== null && minimumSafeguardsSection !== void 0 && minimumSafeguardsSection.id) {
        toCheck.push(completionSection(minimumSafeguardsSection.id, completionMapping));
      }
      toCheck.push(completionResults(questionnaire, completionMapping));
      return arrayAverage.apply(void 0, _toConsumableArray(toCheck));
    };
    var completionResults = function completionResults(questionnaire, completionMapping) {
      var _questionnaire$questi7, _questionnaire$questi8, _questionnaire$questi9, _questionnaire$questi10;
      var activitySections = (_questionnaire$questi7 = (_questionnaire$questi8 = questionnaire.questionnaireTemplate) === null || _questionnaire$questi8 === void 0 ? void 0 : (_questionnaire$questi9 = _questionnaire$questi8.sections) === null || _questionnaire$questi9 === void 0 ? void 0 : _questionnaire$questi9.filter(isEuTaxonomyActivitySection)) !== null && _questionnaire$questi7 !== void 0 ? _questionnaire$questi7 : [];
      var toCheck = activitySections.map(function (section) {
        return completionSection(section.id, completionMapping);
      });
      toCheck.push((_questionnaire$questi10 = questionnaire.questionnaireAssignment) !== null && _questionnaire$questi10 !== void 0 && _questionnaire$questi10.isEditable ? 0 : 1);
      return arrayAverage.apply(void 0, _toConsumableArray(toCheck));
    };
    var alignmentChecks = computed(function () {
      var _questionnaire$questi11, _questionnaire$questi12, _questionnaire$questi13, _questionnaire$questi14, _questionnaire$questi15, _questionnaire$questi16;
      if (!alignmentQuestionnaire.value) return [];
      var questionnaire = alignmentQuestionnaire.value;
      var sections = [];
      var completionMapping = sectionCompletionMapping(questionnaire.questionnaireAssignment);
      sections.push({
        label: $i18n.t('euTaxonomy.navigation.alignmentCheck.label'),
        id: "/".concat(ventureId.value, "/eu-taxonomy/edit/alignment/").concat(questionnaire.id),
        skip: true,
        percentageCompleted: completionAlignmentCheck(questionnaire, completionMapping),
        sections: [{
          label: $i18n.t('euTaxonomy.navigation.intro.label'),
          id: "/".concat(ventureId.value, "/eu-taxonomy/edit/alignment/").concat(questionnaire.id, "/intro")
        }].concat(_toConsumableArray((_questionnaire$questi11 = (_questionnaire$questi12 = questionnaire.questionnaireTemplate) === null || _questionnaire$questi12 === void 0 ? void 0 : (_questionnaire$questi13 = _questionnaire$questi12.sections) === null || _questionnaire$questi13 === void 0 ? void 0 : _questionnaire$questi13.filter(isEuTaxonomyActivitySection).map(function (section) {
          var _section$sections;
          return {
            label: section.label,
            id: "/".concat(ventureId.value, "/eu-taxonomy/edit/alignment/").concat(questionnaire.id, "/").concat(section.id),
            skip: true,
            percentageCompleted: completionSection(section.id, completionMapping),
            sections: section === null || section === void 0 ? void 0 : (_section$sections = section.sections) === null || _section$sections === void 0 ? void 0 : _section$sections.map(function (subSection) {
              return {
                label: subSection.label,
                id: "/".concat(ventureId.value, "/eu-taxonomy/edit/alignment/").concat(questionnaire.id, "/").concat(section.id, "/").concat(subSection.id),
                percentageCompleted: completionSection(subSection.id, completionMapping)
              };
            })
          };
        })) !== null && _questionnaire$questi11 !== void 0 ? _questionnaire$questi11 : []), _toConsumableArray((_questionnaire$questi14 = (_questionnaire$questi15 = questionnaire.questionnaireTemplate) === null || _questionnaire$questi15 === void 0 ? void 0 : (_questionnaire$questi16 = _questionnaire$questi15.sections) === null || _questionnaire$questi16 === void 0 ? void 0 : _questionnaire$questi16.filter(function (section) {
          return section.ixId === euTaxonomyMinimumSafeguardsSectionIxId;
        }).map(function (section) {
          return {
            label: section.label,
            id: "/".concat(ventureId.value, "/eu-taxonomy/edit/alignment/").concat(questionnaire.id, "/").concat(section.id),
            percentageCompleted: completionSection(section.id, completionMapping)
          };
        })) !== null && _questionnaire$questi14 !== void 0 ? _questionnaire$questi14 : []), [{
          label: $i18n.t('euTaxonomy.navigation.results.label'),
          id: "/".concat(ventureId.value, "/eu-taxonomy/edit/alignment/").concat(questionnaire.id, "/results"),
          percentageCompleted: completionResults(questionnaire, completionMapping)
        }])
      });
      return sections;
    });
    return {
      __sfc: true,
      route: route,
      ventureId: ventureId,
      $i18n: $i18n,
      sections: sections,
      accountResult: accountResult,
      accountLoading: accountLoading,
      account: account,
      hasEuTaxonomyCheck: hasEuTaxonomyCheck,
      variables: variables,
      financialEuTaxonomyMetricAssignmentsResult: financialEuTaxonomyMetricAssignmentsResult,
      financialEuTaxonomyMetricAssignmentsLoading: financialEuTaxonomyMetricAssignmentsLoading,
      financialAssignments: financialAssignments,
      completionEligibility: completionEligibility,
      completionAlignmentAssignment: completionAlignmentAssignment,
      sectionCompletionMapping: sectionCompletionMapping,
      completionEuTaxonomyFinancial: completionEuTaxonomyFinancial,
      alignmentQuestionnaire: alignmentQuestionnaire,
      completionSection: completionSection,
      isEuTaxonomyActivitySection: isEuTaxonomyActivitySection,
      completionAlignmentCheck: completionAlignmentCheck,
      completionResults: completionResults,
      alignmentChecks: alignmentChecks
    };
  }
});